import "./step.css";

interface StepProps {
  status: "complete" | "current" | "incomplete";
}

export const Step = ({ status }: StepProps) => {
  const getBackgroundColor = (): string => {
    switch (status) {
      case "complete":
        return "bg-blue-700";
      case "current":
        return "bg-blue-700 loading";
      default:
        return "bg-gray-100";
    }
  };

  return (
    <li className="flex-1">
      <div
        className={`h-2 ${getBackgroundColor()} transition-all duration-300 ease-in-out`}
      />
    </li>
  );
};
